// extracted by mini-css-extract-plugin
module.exports = {"KioskLayout":"KioskLayout_KioskLayout__2LDmD","MapSection":"KioskLayout_MapSection__NYH0T","MenuSection":"KioskLayout_MenuSection__1GhRG"};